import * as React from 'react';
import FullWidthContainer from 'components/FullWidthContainer';
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Button from '@mui/material/Button';
import VideoModal from 'components/VideoModal';
import Grid from '@mui/material/Grid2';
import Image from 'components/Image';

import playButton from 'images/play-button.svg';
import MediaCard from 'components/Cards/MediaCard';


const InlineVideo = ({ videoLoop, thumbnail, video, videoEmbed }) => {
	const [open, setOpen] = React.useState(false);
	const previewVideoRef = React.useRef(null);
	let isInlineVideo = false;

	const resetPreview = () => {
		if (previewVideoRef.current) {
			previewVideoRef.current.pause();
			previewVideoRef.current.currentTime = 0;
			if (thumbnail) previewVideoRef.current.load();
		}
	}

	const playPreview = () => {
		if (!open && previewVideoRef.current) {
			previewVideoRef.current.play();
		}
	}

	const pausePreview = () => {
		if (!open && previewVideoRef.current) resetPreview();
	}

	const playVideo = (evt) => {
		evt.stopPropagation();
		resetPreview();
		setOpen(true);
	}

	const closeVideo = (evt) => {
		evt.stopPropagation();
		resetPreview();
		setOpen(false);
	}

	let videoSrc = '';
	const frameSrcRe = /<iframe(?:[^>+])src=(?:"|')(?<src>[^"|']+)(?:"|')/i;
	const result = frameSrcRe.exec(videoEmbed);
	if (result !== null) videoSrc = result.groups.src;
	if (result === null) isInlineVideo = true;

	return (
		<FullWidthContainer className="SmartTag-root InlineVideo-root">
			<Container>
				<Grid container>
					<Grid size={{ xs: 12 }}>
						<FullWidthContainer className="InlineVideo-thumbnailContainer" onClick={playVideo} onMouseEnter={(videoLoop ? playPreview : null)} onMouseLeave={(videoLoop ? pausePreview : null)}>
							{!isInlineVideo && (
								<>
									{!!videoLoop === false &&
										<>
											<Image src={thumbnail} layout={Image.FULLWIDTH} />
											<Box className="InlineVideo-buttonContainer">
												<Button variant="silent" onClick={playVideo}><img src={playButton} alt="Play Video" /></Button>
											</Box>
										</>
									}
									{!!videoLoop &&
										<Box className="InlineVideo-videoLoop">
											<video ref={previewVideoRef} muted loop playsinline poster={`${process.env.CDN_DOMAIN||''}${thumbnail}`}>
												<source src={`${process.env.CDN_DOMAIN||''}${videoLoop}`} type="video/mp4" />
											</video>
											<Box className="InlineVideo-buttonContainer">
												<Button variant="silent" onClick={playVideo}><img src={playButton} alt="Play Video" /></Button>
											</Box>
										</Box>
									}
								</>
							)}
							{(isInlineVideo && video) && <MediaCard buttonPosition={"topRight"} position={"center"} video={video} />}
						</FullWidthContainer>
					</Grid>
				</Grid>
			</Container>
			{!isInlineVideo && <VideoModal open={open} onClose={closeVideo} alt="video player" src={videoSrc} />}
		</FullWidthContainer>
	)
}

export default InlineVideo;